var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"wrapper"},[_c('div',{staticClass:"attachment-type"},[_c('img',{staticClass:"attachment__close",attrs:{"src":require("../../resource/img/modal/close.svg"),"alt":"close"},on:{"click":_vm.close}}),_c('img',{staticClass:"attachment__back",attrs:{"src":require("../../resource/img/modal/back.svg"),"alt":"back"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }